import React from 'react';
import ReactDOM from 'react-dom/client';
import '@engie-group/fluid-design-tokens/lib/css/tokens.css';
import '@engie-group/fluid-design-system-react/css';
import './index.css';
import 'material-icons/iconfont/material-icons.css';
import App from './App.tsx';

ReactDOM.createRoot(document.getElementById('root')!).render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);
